import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { isWebview, reloadNativeApp } from '@umai/common';
import AppName from 'components/AppName';
import { PartnerContext } from 'contexts/PartnerProvider';
import AccessMessage from 'components/AccessMessage';
import NavLayout from 'components/NavLayout';
import { openUmaiLink } from 'util/url';
import ROUTES from 'constants/routes';
import history from 'util/router-history';

const AuthorizationMessage = () => {
  const [t] = useTranslation();
  const {
    partner: { currentUser },
  } = useContext(PartnerContext);

  return (
    <NavLayout showAppName={false} title="Subscription">
      {currentUser ? (
        <AccessMessage
          header={<AppName type="theme" />}
          title={t('access-denied')}
          description={t('sorry-you-do-not-have-authorization-to-access')}
          subTitle={t('access-message.subtitle')}
          footer={
            <button
              type="button"
              onClick={() => {
                openUmaiLink();
              }}
            >
              {t('access-message.footer')}
            </button>
          }
        />
      ) : (
        <AccessMessage
          header={<AppName type="theme" />}
          title="For some reason, UMAI couldn't load 😥"
          description="Please refresh your browser and verify your internet connection. Should the problem persist,"
          subTitle="Speak to your UMAI account manager for help"
          footer={
            <div>
              <button
                type="button"
                onClick={() => {
                  if (isWebview()) {
                    reloadNativeApp();
                    return;
                  }

                  window?.location?.reload?.();
                }}
              >
                Reload
              </button>
              <button
                type="button"
                onClick={() => {
                  history.push(ROUTES.LOGOUT);
                }}
              >
                Logout
              </button>
            </div>
          }
        />
      )}
    </NavLayout>
  );
};

export default AuthorizationMessage;
